import axios from "axios";

export interface Country {
   id: string;
   alpha_2: string;
   name: string;
   alterntative_names: string[] | null;
   created_at: string;
   updated_at: string;
}

export default class CountriesApi {
   public static getCountries = async (): Promise<Country[]> => {
      const response = await axios.get(`/countries`);
      return response.data?.data;
   };
}
